/**
 * API functions for fetching exchange rates from the backend
 */

import { fetchClient } from "@/lib/api-client";

/**
 * Fetch exchange rates from the backend /exchange-rate/latest endpoint
 * Returns both UVM to USD and USD to IRT rates
 */
export async function fetchExchangeRates() {
  const response = await fetchClient.GET("/exchange-rate/latest");

  if (response.error || !response.data?.data) {
    throw new Error("Failed to fetch exchange rates from backend");
  }

  const { uvm_to_usd, usd_to_irt } = response.data.data;

  return {
    uvmToUsd: parseFloat(uvm_to_usd),
    usdToIrt: parseFloat(usd_to_irt),
  };
}
